import { RowCrudStatus } from "../../common/types";
import {
  MusicalWorkLink,
  MusicalWorkLink_CreateInput,
  MusicalWorkLink_UpdateInput,
} from "../../../api/graphql";
import { LangStore } from "../../../store";
import { platformLinkTypeDisplayId } from "../../platformLinkType/store/PlatformLinkTypeCommonStore";
import { platformDisplayId } from "../../platform/store/PlatformCommonStore";

export type MusicalWorkLinkValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  url: string;
  __platform: string;
  showPlatform: { displayId: string; id: string } | null;
  __type: string;
  showType: { displayId: string; id: string } | null;
};

export type MusicalWorkLinkErrorsType = {
  url?: { message: string; fieldLabel: string };
  platform?: { message: string; fieldLabel: string };
  type?: { message: string; fieldLabel: string };
};

export function MusicalWorkLinkValuesInit(): MusicalWorkLinkValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    url: "",
    __platform: "",
    showPlatform: null,
    __type: "",
    showType: null,
  };
}

export type MusicalWorkLinkType = MusicalWorkLink | MusicalWorkLinkValuesType;

export function musicalWorkLinkDisplayId(
  source: Partial<MusicalWorkLink>,
  _langStore: LangStore
) {
  return (
    (source.type
      ? platformLinkTypeDisplayId(source.type, _langStore)
      : _langStore.emptyStringSymbol) +
    ": " +
    (source.platform
      ? platformDisplayId(source.platform, _langStore)
      : _langStore.emptyStringSymbol)
  );
}

export function getMusicalWorkLinkValues(
  source: MusicalWorkLinkType,
  _langStore: LangStore,
  _duplicated: boolean = false
): MusicalWorkLinkValuesType {
  const entityValues = MusicalWorkLinkValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : musicalWorkLinkDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.url = source.url;
  entityValues.showPlatform =
    "platform" in source && source.platform
      ? {
          id: source.platform.id,
          displayId: platformDisplayId(source.platform, _langStore),
        }
      : "showPlatform" in source && source.showPlatform
      ? { id: source.showPlatform.id, displayId: source.showPlatform.displayId }
      : null;
  entityValues.__platform = entityValues.showPlatform?.displayId || "";
  entityValues.showType =
    "type" in source && source.type
      ? {
          id: source.type.id,
          displayId: platformLinkTypeDisplayId(source.type, _langStore),
        }
      : "showType" in source && source.showType
      ? { id: source.showType.id, displayId: source.showType.displayId }
      : null;
  entityValues.__type = entityValues.showType?.displayId || "";
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}

export function getMusicalWorkLinkUpdateInput(
  values: MusicalWorkLinkValuesType
): MusicalWorkLink_UpdateInput {
  return {
    id: values.id,
    version_: values.version_,
    url: values.url,
    platformId: values.showPlatform?.id || "",
    typeId: values.showType?.id || "",
  };
}

export function getMusicalWorkLinkCreateInput(
  values: MusicalWorkLinkValuesType
): MusicalWorkLink_CreateInput {
  return {
    url: values.url,
    platformId: values.showPlatform?.id || "",
    typeId: values.showType?.id || "",
  };
}
